import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Portfolio.css";
import portfolioastronaut from "../../assets/Portfolio/Astro_Stand_Hologram.gif";
import astronautwalking from "../../assets/Portfolio/astronaut-walking.gif";
import astronautlaptop from "../../assets/Portfolio/astronaut-laptop7.gif";
import rocket from "../../assets/Portfolio/rocket_launches_2.gif";
import client1 from "../../assets/Portfolio/client05.webp";
import client2 from "../../assets/Portfolio/client002.png";
import client3 from "../../assets/Portfolio/client3.webp";
import client4 from "../../assets/Portfolio/client04.webp";
import client5 from "../../assets/Portfolio/client1.webp";
import client6 from "../../assets/Portfolio/client6.webp";
import client7 from "../../assets/Portfolio/client7.webp";
import client8 from "../../assets/Portfolio/client8.webp";
import client9 from "../../assets/Portfolio/client9.webp";
import client10 from "../../assets/Portfolio/client010.webp";
import client11 from "../../assets/Portfolio/client11.webp";
import client12 from "../../assets/Portfolio/client12.webp";
import client13 from "../../assets/Portfolio/client13.webp";
import client14 from "../../assets/Portfolio/client14.webp";
import client15 from "../../assets/Portfolio/client15.webp";
import client16 from "../../assets/Portfolio/client16.webp";
import client17 from "../../assets/Portfolio/client17.webp";
import client18 from "../../assets/Portfolio/client18.webp";
import client19 from "../../assets/Portfolio/client20.webp";
import client20 from "../../assets/Portfolio/client21.webp";
import client21 from "../../assets/Portfolio/client22.webp";
import website1 from "../../assets/Portfolio/portfolio-website1.webp";
import website2 from "../../assets/Portfolio/portfolio-website2.webp";
import website3 from "../../assets/Portfolio/portfolio-website3-1.webp";
import website4 from "../../assets/Portfolio/portfolio-website4.webp";
import website5 from "../../assets/Portfolio/portfolio-website5.webp";
import website6 from "../../assets/Portfolio/portfolio-website6.webp";
import website7 from "../../assets/Portfolio/portfolio-website7.webp";
import website8 from "../../assets/Portfolio/portfolio-website8.webp";
import website9 from "../../assets/Portfolio/portfolio-website9.webp";
import website10 from "../../assets/Portfolio/portfolio-website10.webp";
import website11 from "../../assets/Portfolio/portfolio-website11.webp";
import website12 from "../../assets/Portfolio/portfolio-website12.webp";
import website13 from "../../assets/Portfolio/portfolio-website13.webp";
import website14 from "../../assets/Portfolio/sridhar-portfolio.webp";
import website15 from "../../assets/Portfolio/portfolio-website15.webp";
import website16 from "../../assets/Portfolio/portfolio-website16.webp";

import filedforce from "../../assets/Portfolio/FILEDFORCE.png";
import ahamart from "../../assets/Portfolio/AHAMART.png";

import mobile1 from "../../assets/Portfolio/portfolio-mobile1.webp";
import mobile2 from "../../assets/Portfolio/portfolio-mobile2.webp";
import mobile3 from "../../assets/Portfolio/portfolio-mobile3-1.webp";
import mobile4 from "../../assets/Portfolio/portfolio-mobile4-1.webp";
import mobile5 from "../../assets/Portfolio/portfolio-mobile5.webp";
import mobile6 from "../../assets/Portfolio/portfolio-mobile6.webp";
import mobile7 from "../../assets/Portfolio/portfolio-mobile7.webp";
import mobile8 from "../../assets/Portfolio/portfolio-mobile8.webp";

import mobile9 from "../../assets/Portfolio/portfolio-mobile8.webp";
import mobile10 from "../../assets/Portfolio/portfolio-mobile8.webp";

import software1 from "../../assets/Portfolio/portfolio-software1.webp";
import software2 from "../../assets/Portfolio/portfolio-software2.webp";
import software3 from "../../assets/Portfolio/portfolio-software3.webp";
import software4 from "../../assets/Portfolio/portfolio-software4-1.webp";
import software5 from "../../assets/Portfolio/portfolio-software5.webp";
import software6 from "../../assets/Portfolio/portfolio-software6.webp";
import software7 from "../../assets/Portfolio/portfolio-website17.webp";
import uiux1 from "../../assets/Portfolio/ui-design.webp";
import uiux2 from "../../assets/Portfolio/ux-flow.webp";
import uiux3 from "../../assets/Portfolio/prototype.webp";
import uiux4 from "../../assets/Portfolio/mobile-ui.webp";
import uiux5 from "../../assets/Portfolio/design-system.webp";
import uiux6 from "../../assets/Portfolio/wireframe.webp";
import dm1 from "../../assets/Portfolio/portfolio-dm1.webp";
import dm2 from "../../assets/Portfolio/portfolio-dm2.webp";
import dm3 from "../../assets/Portfolio/portfolio-dm3.webp";
import dm4 from "../../assets/Portfolio/portfolio-dm4.webp";
import dm5 from "../../assets/Portfolio/portfolio-dm5.webp";
import health from "../../assets/Portfolio/health.webp";
import education from "../../assets/Portfolio/education.webp";
import transport from "../../assets/Portfolio/transport.webp";
import finance from "../../assets/Portfolio/finance.webp";
import marketing from "../../assets/Portfolio/marketing.webp";
import food from "../../assets/Portfolio/food.webp";
import ecommerce from "../../assets/Portfolio/e-commerce.webp";
import realestate from "../../assets/Portfolio/real-estate.webp";
import eventmanagement from "../../assets/Portfolio/events.webp";
import logo1 from "../../assets/Portfolio/logo1.svg";
import logo2 from "../../assets/Portfolio/logo2.svg";
import logo3 from "../../assets/Portfolio/logo3.svg";
import logo4 from "../../assets/Portfolio/logo4.svg";
import logo5 from "../../assets/Portfolio/logo5.svg";
import logo6 from "../../assets/Portfolio/logo6.svg";
import logo7 from "../../assets/Portfolio/logo7.svg";
import logo8 from "../../assets/Portfolio/logo8.svg";
import logo9 from "../../assets/Portfolio/logo9.svg";
import logo10 from "../../assets/Portfolio/logo10.svg";
import logo11 from "../../assets/Portfolio/logo11.svg";
import logo12 from "../../assets/Portfolio/logo12.svg";
import logo13 from "../../assets/Portfolio/logo13.svg";
import logo14 from "../../assets/Portfolio/logo14.svg";
import logo15 from "../../assets/Portfolio/logo15.svg";
import logo16 from "../../assets/Portfolio/logo16.svg";
import expertiseMobile from "../../assets/Portfolio/logo1.svg";
import expertiseWeb from "../../assets/Portfolio/logo17.svg";
import expertiseReactNative from "../../assets/Portfolio/logo3.svg";
import expertiseWebsite from "../../assets/Portfolio/logo4.svg";
// import expertiseERP from '../../assets/images/logo3.svg'
import expertiseAdmin from "../../assets/Portfolio/logo1.svg";
// import expertiseUIUX from '../../assets/images/logo13.svg'
import expertiseBackend from "../../assets/Portfolio/logo16.svg";
import { Helmet } from "react-helmet-async";
import filedforcedashboard from "../../assets/Portfolio/filed-force-dashboard.png";
import amruthahospital from "../../assets/Portfolio/amrutha-hospital.webp";
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// useEffect(() => {
//   AOS.init({
//     duration: 800,
//     easing: 'ease-out-cubic',
//     once: true,
//   });
// }, []);
// Dummy project data - REPLACE WITH YOUR ACTUAL PROJECTS

// Add this useEffect to force mobile styles

const projectData = {
  website: [
    { title: "SRIDHAR", image: website14, category: "website" },
    { title: "AMRUTHA HOSPITAL", image: amruthahospital, category: "website" },
    {
      title: "Filed Force Dashboard",
      image: filedforcedashboard,
      category: "software",
    },
    {
      title: "Siddhi Ganapathi Developers",
      image: website15,
      category: "website",
      url: "https://siddhiganapathi.com/",
    },
    {
      title: "Sri Balaji Group Of Industries",
      image: website4,
      category: "website",
    },
    {
      title: "Sanjay Ghodawat University",
      image: website3,
      category: "website",
      url: "https://www.sanjayghodawat.co.in/",
    },

    {
      title: "SANDIP UNIVERSITY",
      image: website5,
      category: "website",
      url: "https://www.sandipuniversity.edu.in/",
    },

    {
      title: "RAYUDU GARI MILITARY HOTEL",
      image: website6,
      category: "website",
      url: "https://rgmhotel.com/",
    },
    {
      title: "ORION TECHNICAL COLLEGE",
      image: website7,
      category: "website",
      url: "https://orion.edu/",
    },
    {
      title: "CYIENT",
      image: website8,
      category: "website",
      url: "https://www.cyient.com/geospatial/earth-observation",
    },
    {
      title: "CYCLOMEDIA",
      image: website9,
      category: "website",
      url: "https://www.cyclomedia.com/en/products/data-insights/geo-objects",
    },
    {
      title: "UNIHARBOUR",
      image: website10,
      category: "website",
      url: "https://www.uniharbour.com/",
    },
    {
      title: "SRI JYOTHI POLYTECHNIC",
      image: website2,
      category: "website",
      url: "https://srijyothipolytechnic.com/",
    },
    {
      title: "ASIAN CROP CARE",
      image: website16,
      category: "website",
      url: "https://asiancropcare.co/",
    },
    {
      title: "SRI ANJANEYA RESTAURANTS",
      image: website11,
      category: "website",
    },
    { title: "GSR FARMS AND FOODS", image: website12, category: "website" },
    { title: "SKII ARTS", image: website1, category: "website" },
    { title: "PENTIP", image: website13, category: "website" },
  ],
  mobile: [
    { title: "Dhan Shakti", image: mobile1, category: "mobile" },
    { title: "FILED FORCE", image: filedforce, category: "mobile" },
    { title: "AHA MART", image: ahamart, category: "mobile" },

    { title: "High Ghar", image: mobile2, category: "mobile" },
    { title: "Oakya Ecom App", image: mobile3, category: "mobile" },
    { title: "Oakya Home Services", image: mobile4, category: "mobile" },
    { title: "Mech Guru", image: mobile5, category: "mobile" },
    { title: "School App", image: mobile6, category: "mobile" },
    { title: "Campus Connect", image: mobile7, category: "mobile" },
    { title: "Gait View", image: mobile8, category: "mobile" },
  ],
  software: [
    { title: "Indrashil University", image: software1, category: "software" },
    { title: "Dhan Shakti Admin", image: software2, category: "software" },
    { title: "School ERP", image: software6, category: "software" },
    { title: "Mech Guru", image: software7, category: "software" },
    {
      title: "Indrashil University (bipc)",
      image: software3,
      category: "software",
    },
    {
      title: "Sanjay Ghodawat University",
      image: software4,
      category: "software",
    },
    { title: "High Ghar", image: software5, category: "software" },
    { title: "AMRUTHA HOSPITAL", image: amruthahospital, category: "website" },
    {
      title: "Filed Force Dashboard",
      image: filedforcedashboard,
      category: "software",
    },
  ],
  uiux: [
    { title: "wire frame", image: uiux6, category: "uiux" },
    { title: "UI Design", image: uiux1, category: "uiux" },
    { title: "UX Flow", image: uiux2, category: "uiux" },
    { title: "Prototyping Tool", image: uiux3, category: "uiux" },
    { title: "Mobile UI", image: uiux4, category: "uiux" },
    { title: "Design System", image: uiux5, category: "uiux" },
  ],
  marketing: [
    { title: "SEO Optimization", image: dm1, category: "marketing" },
    { title: "Social Campaign", image: dm2, category: "marketing" },
    { title: "Email Marketing", image: dm3, category: "marketing" },
    { title: "PPC Advertising", image: dm4, category: "marketing" },
    { title: "Content Marketing", image: dm5, category: "marketing" },
  ],
};

const Portfolio = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeCategory, setActiveCategory] = useState("website");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const sectionsRef = useRef([]);
  const rocketRef = useRef(null);

  // LOGO CARDS REFS - FOR SIMULATE
  const logoCardRefs = useRef([]);
  // LOGO CARDS REFS - 9 CARDS FOR ADAPTED
  const adaptedLogoCardRefs = useRef(new Array(9).fill(null));

  const allClients = [
    client1,
    client2,
    client3,
    client4,
    client5,
    client6,
    client7,
    client8,
    client9,
    client10,
    client11,
    client12,
    client13,
    client14,
    client15,
    client16,
    client17,
    client18,
    client19,
    client20,
    client21,
  ];
  const clientsPerPage = 9;
  const totalPages = Math.ceil(allClients.length / clientsPerPage);
  const currentClients = allClients.slice(
    currentPage * clientsPerPage,
    (currentPage + 1) * clientsPerPage,
  );

  useEffect(() => {
    logoCardRefs.current = new Array(9).fill(null);
  }, [currentPage]);

  //   useLayoutEffect(() => {
  //   let ticking = false;
  //   let prevScroll = window.scrollY;
  //   const heroSection = document.querySelector('.hero');
  //   const heroHeight = heroSection ? heroSection.offsetHeight : window.innerHeight;

  //   const handleScroll = () => {
  //     if (!ticking) {
  //       requestAnimationFrame(() => {
  //         const currentScroll = window.scrollY;
  //         setScrollY(currentScroll);

  //         // Check if the hero section is in view (scroll position is within hero section height)
  //         if (currentScroll <= heroHeight && rocketRef.current) {
  //           // Trigger animation on scroll down or up
  //           if (currentScroll !== prevScroll) {
  //             rocketRef.current.style.animation = 'none';
  //             rocketRef.current.offsetHeight; // Trigger reflow
  //             rocketRef.current.style.animation = 'rocketFlight 10s ease-in-out forwards';
  //           }
  //         }

  //         prevScroll = currentScroll;
  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   window.addEventListener('resize', handleScroll);
  //   handleScroll(); // Initial call to set up animation if already in view

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //     window.removeEventListener('resize', handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const els = entry.target.querySelectorAll(".animate-from-bottom");
          if (entry.isIntersecting) {
            els.forEach((el) => el.classList.add("reveal"));
          } else {
            els.forEach((el) => el.classList.remove("reveal"));
          }
        });
      },
      { threshold: 0.3 },
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });
    return () => observer.disconnect();
  }, []);

  // **3D MOUSEMOVE EFFECT - FOR SIMULATE**
  useEffect(() => {
    const handleMouseMove = (e) => {
      logoCardRefs.current.forEach((card) => {
        if (!card) return;

        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const mouseX = ((x - centerX) / centerX) * 100;
        const mouseY = ((y - centerY) / centerY) * 100;

        card.style.setProperty("--mouse-x", `${mouseX.toFixed(2)}`);
        card.style.setProperty("--mouse-y", `${mouseY.toFixed(2)}`);
      });
    };

    const simulateLeft = document.querySelector(".simulate-left");
    if (simulateLeft) {
      simulateLeft.addEventListener("mousemove", handleMouseMove);

      simulateLeft.addEventListener("mouseleave", () => {
        logoCardRefs.current.forEach((card) => {
          if (!card) return;
          card.style.setProperty("--mouse-x", "0");
          card.style.setProperty("--mouse-y", "0");
        });
      });
    }

    return () => {
      if (simulateLeft) {
        simulateLeft.removeEventListener("mousemove", handleMouseMove);
        simulateLeft.removeEventListener("mouseleave", () => {});
      }
    };
  }, [currentPage]);

  // **3D MOUSEMOVE EFFECT - 9 CARDS FOR ADAPTED**
  useEffect(() => {
    const handleMouseMove = (e) => {
      adaptedLogoCardRefs.current.forEach((card) => {
        if (!card) return;

        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const mouseX = ((x - centerX) / centerX) * 100;
        const mouseY = ((y - centerY) / centerY) * 100;

        card.style.setProperty("--mouse-x", `${mouseX.toFixed(2)}`);
        card.style.setProperty("--mouse-y", `${mouseY.toFixed(2)}`);
      });
    };

    const adaptedRight = document.querySelector(".adapted-right");
    if (adaptedRight) {
      adaptedRight.addEventListener("mousemove", handleMouseMove);

      adaptedRight.addEventListener("mouseleave", () => {
        adaptedLogoCardRefs.current.forEach((card) => {
          if (!card) return;
          card.style.setProperty("--mouse-x", "0");
          card.style.setProperty("--mouse-y", "0");
        });
      });
    }

    return () => {
      if (adaptedRight) {
        adaptedRight.removeEventListener("mousemove", handleMouseMove);
        adaptedRight.removeEventListener("mouseleave", () => {});
      }
    };
  }, []);

  const setSectionRef = useCallback(
    (index) => (el) => {
      sectionsRef.current[index] = el;
    },
    [],
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Handle form submission here (e.g., send to API)
  };

  const categories = [
    { id: "website", label: "Website" },
    { id: "mobile", label: "Mobile App" },
    { id: "software", label: "Software" },
    { id: "uiux", label: "UI/UX" },
    { id: "marketing", label: "Digital Marketing" },
  ];

  const currentProjects = projectData[activeCategory];

  const industries = [
    {
      name: "HEALTH",
      image: health,
      url: "https://demosite.oakyaitservices.com/oakyaprojects/healthcare/main/index.html",
    },
    {
      name: "EDUCATION",
      image: education,
      url: "https://schoolerp.oakyaitservices.in/",
    },
    {
      name: "TRANSPORT",
      image: transport,
      url: "https://demosite.oakyaitservices.com/oakyaprojects/travels/index.html",
    },
    { name: "FINANCE", image: finance },
    { name: "MARKETING", image: marketing },
    {
      name: "FOOD",
      image: food,
      url: "https://demosite.oakyaitservices.com/oakyaprojects/food/index.html",
    },
    {
      name: "E-COMMERCE",
      image: ecommerce,
      url: "https://demosite.oakyaitservices.com/oakyaprojects/ecomm/index.html",
    },
    {
      name: "REAL-ESTATE",
      image: realestate,
      url: "https://siddhiganapathi.com/",
    },
    { name: "EVENT-MANAGEMENT", image: eventmanagement },
  ];

  return (
    <main role="main" className="portfolio-wrapper">
      <Helmet>
        <title>
          Portfolio | Our Projects & Success Stories | Oakya IT Services
        </title>
        <meta
          name="description"
          content="Explore Oakya IT Services portfolio featuring successful projects in software development, mobile apps, digital marketing, branding, and web solutions."
        />
        <meta
          name="keywords"
          content="web portfolio, mobile app portfolio, e-commerce projects, UI/UX showcase, IT projects Vijayawada"
        />
        <meta name="author" content="Oakya IT Services" />
        <meta name="robots" content="index, follow" />
        <meta name="publisher" content="Oakya IT Services" />
        <link rel="canonical" href="https://oakyaitservices.com/portfolio" />
        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Our Portfolio | Oakya IT Services Vijayawada"
        />
        <meta
          property="og:description"
          content="Explore our portfolio of website, mobile app, e-commerce & UI/UX projects delivered for
businesses in Vijayawada and beyond."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://oakyaitservices.com/portfolio"
        />
      </Helmet>
      {/* === HERO SECTION === */}
      <section ref={setSectionRef(0)} className="section hero" id="hero">
        <div className="content hero-content">
          <h1 className="hero-title animate-from-bottom">
            Empowering Digital Innovation
          </h1>
          <p className="hero-subtitle animate-from-bottom delay-1">
            Transforming businesses into digital success stories through
            creativity, strategy, and technology.
          </p>
          <button
            className="hero-cta animate-from-bottom delay-2 base-button"
            onClick={() => {
              const section = document.getElementById("tech");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            View Our Work →
          </button>
        </div>
        <div className="hero-rocket-container">
          <img
            src={rocket}
            alt="Rocket launching"
            className="hero-rocket"
            loading="lazy"
          />
        </div>
      </section>

      {/* === FEATURES SECTION === */}
      <section
        ref={setSectionRef(1)}
        className="section features"
        id="features"
      >
        <div className="features-content">
          <div className="features-main-heading animate-from-bottom">
            <h2 className="features-title">Our Philosophy.</h2>
          </div>
          <div className="features-subtitle animate-from-bottom delay-1">
            <p>Beyond Code, We Build Experiences.</p>
            <p>
              We view technology as an art form—crafted with precision, passion,
              and purpose. Every project begins with a vision to simplify,
              engage, and leave a lasting impact.
            </p>
          </div>
          <div className="features-paragraphs animate-from-bottom delay-2">
            <div className="features-paragraph-left ">
              <p>
                <strong>Innovation Meets Functionality: </strong>
                Bringing together design brilliance, technical expertise, and
                strategic insight to create intelligent digital ecosystems that
                work beautifully and perform flawlessly.By blending emotional
                insight with data-driven strategy, we create designs that
                inspire engagement and drive meaningful results.
              </p>
            </div>
            <div className="features-paragraph-right ">
              <p>
                <strong>Human-Centered Design: </strong>
                Our approach starts with empathy. We design solutions that
                connect deeply with users and align seamlessly with business
                objectives.We listen, observe, and understand real user needs to
                craft experiences that feel natural and intuitive.Every
                interaction is thoughtfully designed to create lasting value—for
                people, businesses, and the world around them.
              </p>
            </div>
          </div>
          <div className="features-buttons animate-from-bottom delay-3">
            <a href="#contact">
              <button className="features-btn-ai-vr base-button">
                ← Contact Us
              </button>
            </a>
            <a href="#simulate">
              <button className="features-btn-skill-build base-button">
                Our Clients →
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* === OUR EXPERTISE SECTION - SIMPLE LAYOUT === */}
      <section
        ref={setSectionRef(2)}
        className="section expertise-simple"
        id="expertise"
      >
        <div className="expertise-simple-container">
          {/* <!-- HEADER --> */}
          <div className="expertise-header animate-from-bottom">
            <h2 className="expertise-title">Our Expertise</h2>
            <p className="expertise-subtitle animate-from-bottom delay-1">
              We craft digital solutions powered by innovation and driven by
              technology — delivering seamless experiences across web and mobile
              platforms.
            </p>
          </div>

          {/* <!-- TECHNOLOGIES SECTION --> */}
          <div className="technologies-section animate-from-bottom delay-2">
            <h3 className="technologies-title">Technologies We Master</h3>
            <p className="technologies-subtitle animate-from-bottom delay-3">
              We bring ideas to life using the latest, most reliable tech stack
            </p>
            <div className="technologies-grid">
              <div className="tech-card animate-from-bottom delay-4">
                <img
                  src={expertiseWeb}
                  alt="React JS"
                  className="tech-icon"
                  loading="lazy"
                />
                <p className="tech-description">
                  Fast, dynamic, and engaging user interfaces
                </p>
              </div>
              <div className="tech-card animate-from-bottom delay-5">
                <img
                  src={expertiseBackend}
                  alt=".NET"
                  className="tech-icon"
                  loading="lazy"
                />
                <p className="tech-description">
                  Secure and enterprise-ready backend systems
                </p>
              </div>
              <div className="tech-card animate-from-bottom delay-6">
                <img
                  src={expertiseReactNative}
                  alt="React Native"
                  className="tech-icon"
                  loading="lazy"
                />
                <p className="tech-description">
                  Cross-platform mobile apps with native performance
                </p>
              </div>
              <div className="tech-card animate-from-bottom delay-7">
                <img
                  src={expertiseAdmin}
                  alt="Node JS"
                  className="tech-icon"
                  loading="lazy"
                />
                <p className="tech-description">
                  Scalable and high-performing server-side solutions
                </p>
              </div>
            </div>
          </div>

          {/* <!-- SERVICES SECTION --> */}
          <div className="services-section animate-from-bottom delay-8">
            <h3 className="services-title">What We Build</h3>
            <p className="services-subtitle animate-from-bottom delay-9">
              By combining these technologies, we create powerful and elegant
              digital products
            </p>
            <div className="services-grid">
              <div className="service-card animate-from-bottom delay-10">
                <img
                  src={expertiseMobile}
                  alt="Mobile App Development"
                  className="service-icon"
                  loading="lazy"
                />
                <h3 className="service-card-title">Mobile App Development</h3>
                <p className="service-card-tagline">Innovation in every tap</p>
                <p className="service-card-text">
                  Sleek, high-performance apps that connect and convert
                </p>
              </div>
              <div className="service-card animate-from-bottom delay-11">
                <img
                  src={expertiseWeb}
                  alt="Web Development"
                  className="service-icon"
                  loading="lazy"
                />
                <h3 className="service-card-title">Web Development</h3>
                <p className="service-card-tagline">
                  Smart, scalable, and stunning
                </p>
                <p className="service-card-text">
                  Scalable, dynamic, and user-centric web applications
                </p>
              </div>
              <div className="service-card animate-from-bottom delay-12">
                <img
                  src={expertiseWebsite}
                  alt="Robust Website Development"
                  className="service-icon"
                  loading="lazy"
                />
                <h3 className="service-card-title">
                  Robust Website Development
                </h3>
                <p className="service-card-tagline">
                  Your digital identity, redefined
                </p>
                <p className="service-card-text">
                  Reliable, secure, and visually stunning websites
                </p>
              </div>
            </div>
          </div>

          {/* <!-- STATS SECTION --> */}
          <div className="expertise-stats animate-from-bottom delay-13">
            <div className="stat-item animate-from-bottom delay-14">
              <span className="stat-number">500+</span>
              <span className="portfolio-stat-label">Projects Delivered</span>
            </div>
            <div className="stat-item animate-from-bottom delay-15">
              <span className="stat-number">98%</span>
              <span className="portfolio-stat-label">Client Satisfaction</span>
            </div>
            <div className="stat-item animate-from-bottom delay-16">
              <span className="stat-number">50+</span>
              <span className="portfolio-stat-label">Expert Team</span>
            </div>
          </div>
        </div>
      </section>

      {/* === TECH SECTION - PORTFOLIO GRID === */}
      <section ref={setSectionRef(3)} className="section tech" id="tech">
        <div className="tech-content">
          <h2 className="tech-main-title animate-from-bottom">
            {activeCategory === "website"
              ? "WEBSITE DEVELOPMENT"
              : activeCategory === "mobile"
                ? "MOBILE APP DEVELOPMENT"
                : activeCategory === "software"
                  ? "SOFTWARE DEVELOPMENT"
                  : activeCategory === "uiux"
                    ? "UI/UX DESIGN"
                    : "DIGITAL MARKETING"}{" "}
            PROJECTS
          </h2>

          <div className="tech-category-buttons animate-from-bottom delay-1">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? "active" : ""}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>

          <div className="tech-projects-grid animate-from-bottom delay-2">
            {currentProjects.map((project, index) => (
              <div
                key={index}
                className={`project-card ${activeCategory === "mobile" ? "mobile-project" : ""} ${
                  project.url ? "clickable" : ""
                }`}
              >
                {project.url ? (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    <div className="project-image-wrapper">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="project-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="project-info">
                      <h3 className="project-title">{project.title}</h3>
                    </div>
                  </a>
                ) : (
                  <>
                    <div className="project-image-wrapper">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="project-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="project-info">
                      <h3 className="project-title">{project.title}</h3>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* === SIMULATE SECTION - 3x3 GRID LOGOS WITH ARROW PAGINATION === */}
      <section
        ref={setSectionRef(4)}
        className="section simulate"
        id="simulate"
      >
        <div className="simulate-container">
          <div className="simulate-left">
            <h3 className="logo-cards-title animate-from-bottom">
              Our Clients
            </h3>

            {/* ARROW NAVIGATION CONTAINER */}
            <div className="logo-navigation-wrapper animate-from-bottom delay-1">
              {/* PREV ARROW - LEFT SIDE ❮ */}
              <button
                className="nav-arrow prev-arrow"
                onClick={() => setCurrentPage((prev) => Math.max(0, prev - 1))}
                disabled={currentPage === 0}
                aria-label="Previous page"
              >
                ❮
              </button>

              {/* 3x3 GRID LOGO CARDS */}
              <div className="logo-cards-container animate-from-bottom delay-2">
                <div className="logo-cards">
                  {currentClients.map((src, index) => (
                    <div
                      key={`${currentPage}-${index}`}
                      className="logo-card"
                      ref={(el) => (logoCardRefs.current[index] = el)}
                    >
                      <div className="logo-card__bg"></div>
                      <img
                        className="logo-card__img"
                        src={src}
                        alt={`Client Logo ${currentPage * 9 + index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* NEXT ARROW - RIGHT SIDE ❯ */}
              <button
                className="nav-arrow next-arrow"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(totalPages - 1, prev + 1))
                }
                disabled={currentPage === totalPages - 1}
                aria-label="Next page"
              >
                ❯
              </button>

              {/* PAGE INDICATOR - BELOW GRID */}
              <div className="page-indicator">
                {currentPage + 1} / {totalPages}
              </div>
            </div>
          </div>

          <div className="simulate-right">
            <div className="simulate-angled-bg">
              <img
                src={portfolioastronaut}
                alt="Astronaut"
                className="astronaut-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* === ADAPTED SECTION - MANUALLY PLACED LOGOS === */}
      <section ref={setSectionRef(5)} className="section adapted" id="adapted">
        <div className="adapted-container">
          <div className="adapted-left">
            <div className="adapted-angled-bg">
              <img
                src={astronautlaptop}
                alt="Astronaut laptop"
                className="adapted-astronaut-img"
                loading="lazy"
              />
            </div>
          </div>

          <div className="adapted-right">
            <h3 className="logo-cards-title animate-from-bottom">
              Our Technologies
            </h3>

            {/* LOGO CAROUSEL CONTAINERS - MANUALLY PLACED */}
            <div className="logo-carousel-wrapper animate-from-bottom delay-1">
              {/* FIRST CONTAINER - 6 LOGOS, 150px size, LEFT→RIGHT */}
              <div className="logo-container">
                <img src={logo1} alt="Logo 1" loading="lazy" />
                <img src={logo2} alt="Logo 2" loading="lazy" />
                <img src={logo3} alt="Logo 3" loading="lazy" />
                <img src={logo4} alt="Logo 4" loading="lazy" />
                <img src={logo5} alt="Logo 5" loading="lazy" />
                <img src={logo6} alt="Logo 6" loading="lazy" />
              </div>

              {/* SECOND CONTAINER - 6 LOGOS, 100px size, RIGHT→LEFT (REVERSE) */}
              <div
                className="logo-container reverse"
                style={{
                  "--n": "3",
                  "--s": "100px",
                  maxWidth: "500px",
                }}
              >
                <img src={logo7} alt="Logo 7" loading="lazy" />
                <img src={logo8} alt="Logo 8" loading="lazy" />
                <img src={logo9} alt="Logo 9" loading="lazy" />
                <img src={logo10} alt="Logo 10" loading="lazy" />
                <img src={logo11} alt="Logo 11" loading="lazy" />
                <img src={logo12} alt="Logo 12" loading="lazy" />
              </div>

              {/* THIRD CONTAINER - 4 LOGOS, 100px size, LEFT→RIGHT */}
              <div
                className="logo-container"
                style={{
                  "--n": "3",
                  "--s": "100px",
                  maxWidth: "300px",
                }}
              >
                <img src={logo13} alt="Logo 13" loading="lazy" />
                <img src={logo14} alt="Logo 14" loading="lazy" />
                <img src={logo15} alt="Logo 15" loading="lazy" />
                <img src={logo16} alt="Logo 16" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === SAFE SECTION === */}
      <section ref={setSectionRef(6)} className="section safe" id="safe">
        <div className="content safe-content">
          <h2 className="section-title animate-from-bottom">
            We Serve a Wide Variety of Industries 🚀
          </h2>
          <p className="section-desc animate-from-bottom delay-1">
            Innovative projects delivered across galaxies of industries.
          </p>
          <div className="industries-grid animate-from-bottom delay-2">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="industry-card"
                onClick={() => {
                  if (industry.url) {
                    window.open(industry.url, "_blank", "noopener,noreferrer"); // Opens in a new tab safely
                  }
                }}
                style={{ cursor: industry.url ? "pointer" : "default" }}
              >
                <div className="industry-image">
                  <img
                    src={industry.image}
                    alt={industry.name}
                    loading="lazy"
                  />
                </div>
                <h3 className="industry-label">{industry.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* === CLIENT REVIEW SECTION === */}
      <section
        ref={setSectionRef(7)}
        className="section client-reviews"
        id="reviews"
      >
        <div className="content reviews-content">
          <h2 className="section-title animate-from-bottom">
            Client Success Stories
          </h2>
          <p className="section-desc animate-from-bottom delay-1">
            Don't just take our word for it. Hear from our satisfied clients.
          </p>

          <div className="reviews-carousel animate-from-bottom delay-2">
            <div className="reviews-carousel-inner">
              {/* REVIEW CARD 1 */}
              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client21}
                    alt="Prasad"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">Prasad</h4>
                    <p className="review-role">BCT, Team BCT.</p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "Working with Oakya IT Services has been a great experience.
                  Their team understood our goals and delivered effective
                  marketing strategies that boosted our visibility and brought
                  in quality clients. A reliable and proactive team!"
                </p>
              </div>

              {/* REVIEW CARD 2 */}
              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client3}
                    alt="Ramana"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">Sri S.V. Ramana</h4>
                    <p className="review-role">
                      Founder, Jyothi polytechnique colleges
                    </p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "Oakya IT Services designed a modern and user-friendly website
                  for our college. Their professionalism and timely delivery
                  have greatly improved our online presence. We’re very
                  satisfied with their service."
                </p>
              </div>

              {/* REVIEW CARD 3 */}
              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client20}
                    alt="Jagadeesh"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">Jagadeesh</h4>
                    <p className="review-role">Founder, Asian Crop Care</p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "Oakya IT Services helped us strengthen our digital presence
                  with their excellent marketing and web design services. Their
                  work made it easier for us to connect with farmers and
                  distributors. A very professional and effective team!"
                </p>
              </div>

              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client19}
                    alt="Venkata Chowdary"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">M. Venkata Chowdary</h4>
                    <p className="review-role">
                      Restaurant, Rayudu Gari Military Hotel.
                    </p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "Partnering with Oakya IT Services transformed our online
                  presence. They handled everything from branding to website
                  design, capturing our restaurant’s true essence. Highly
                  recommended for anyone looking to grow digitally."{" "}
                </p>
              </div>

              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client11}
                    alt="Deepak Jain"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">Deepak Jain</h4>
                    <p className="review-role">Founder, Dhan Shakti</p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "We partnered with Oakya IT Services for our mobile app and
                  website development, and the results exceeded our
                  expectations. Their technical expertise and smooth
                  communication made the entire process easy and efficient.
                  Highly recommended!"
                </p>
              </div>

              <div className="review-card">
                <div className="review-header">
                  <img
                    src={client13}
                    alt="Subramanyam Reddy"
                    className="review-avatar"
                    loading="lazy"
                  />
                  <div className="review-author">
                    <h4 className="review-name">Subramanyam Reddy</h4>
                    <p className="review-role">Founder, GSR Farms and Foods</p>
                  </div>
                </div>
                <div className="review-stars">
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                  <span className="star">★</span>
                </div>
                <p className="review-text">
                  "Working with Oakya IT Services has been a smooth and
                  productive experience. Their digital marketing strategies
                  helped us reach the right audience and grow our client base
                  effectively. A professional and trustworthy team!"
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === CONTACT SECTION === */}
      <section ref={setSectionRef(8)} className="section contact" id="contact">
        <div className="easy-astronaut-center">
          <img
            src={astronautwalking}
            alt="Astronaut walking"
            className="easy-astronaut-img"
            loading="lazy"
          />
        </div>
        <div className="content contact-content">
          <h2 className="portfolio-contact-title animate-from-bottom">
            CONTACT US
          </h2>
          <p className="contact-subtitle animate-from-bottom delay-1">
            Let's collaborate on your next cosmic project.
          </p>
          <form
            className="contact-form animate-from-bottom delay-2"
            onSubmit={handleSubmit}
          >
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleInputChange}
              rows="5"
              required
            ></textarea>
            <button type="submit" className="send-btn">
              Send Message
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Portfolio;
